import { CORE_SEAT_LEVEL_TO_API_NAME } from 'pricing-pages-lib/utils/productsUtils';
import { ENTERPRISE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { CORE_SEAT } from 'self-service-api/constants/UnitNames';
import { useAppSelector } from '../reducers';
import { includedSeatQuantityForProductConfigurationSelector } from '../selectors/ProductConfigsSelectors';
import { coreSeatSkuForProductLevelSelector, productForSkuIdSelector, seatUnitNameForSkuIdSelector, skuIdIsOrHasHubSelector, skuIdIsSalesSeatSelector, skuIdIsServiceSeatSelector } from '../selectors/ProductsSelectors';
import { useGlobalLoading } from './loadingHooks';
import { useTotalUsers } from './useSeatsInventory';
export const useRequestedProductsAdditionalSeats = ({
  productConfigurations
}) => {
  const {
    totalUsers
  } = useTotalUsers();
  const isAppReady = useGlobalLoading();
  return useAppSelector(state => {
    const requestedProducts = [];
    if (productConfigurations.length === 0 || !isAppReady) {
      return requestedProducts;
    }
    productConfigurations.forEach(productConfiguration => {
      const {
        skuId,
        quantity
      } = productConfiguration;
      const {
        apiName,
        productLevel
      } = productForSkuIdSelector(state, {
        skuId
      });
      const isPaidProductLevel = [STARTER, PROFESSIONAL, ENTERPRISE].includes(productLevel);
      const skuIdIsOrHasHub = skuIdIsOrHasHubSelector(state, {
        skuId
      });
      if (!isPaidProductLevel || !skuIdIsOrHasHub) {
        return false;
      }
      const isSalesSeatSku = skuIdIsSalesSeatSelector(state, {
        skuId
      });
      const isServiceSeatSku = skuIdIsServiceSeatSelector(state, {
        skuId
      });
      const coreSeatSkuForProductLevel = coreSeatSkuForProductLevelSelector(state, {
        productLevel: productLevel
      });
      if (!isSalesSeatSku && !isServiceSeatSku && !coreSeatSkuForProductLevel) {
        return false;
      }
      const coreSeatSkuId = coreSeatSkuForProductLevel.skuId;
      const primarySeatSkuId = isSalesSeatSku || isServiceSeatSku ? skuId : coreSeatSkuId;
      const primarySeatApiName = isSalesSeatSku || isServiceSeatSku ? apiName : CORE_SEAT_LEVEL_TO_API_NAME[productLevel];
      const seatUnitName = seatUnitNameForSkuIdSelector(state, {
        skuId: primarySeatSkuId
      });
      const includedSeats = includedSeatQuantityForProductConfigurationSelector(state, {
        seatUnitName,
        productConfigurations
      });
      if (quantity < totalUsers || primarySeatSkuId === coreSeatSkuId) {
        const hasIncludedCoreSeat = seatUnitName === CORE_SEAT && includedSeats > 0;

        // Remove included core seats from the additional seat quantity count
        const startingAdditionalSeats = hasIncludedCoreSeat ? totalUsers - includedSeats : totalUsers;
        if (startingAdditionalSeats > 0) {
          requestedProducts.push({
            productApiName: primarySeatApiName,
            totalQuantity: startingAdditionalSeats
          });
        }
      }
    });
    return requestedProducts;
  });
};